import React from 'react'
import Cookies from 'js-cookie'
import Palette from './assets/palette'
import Dismiss from './assets/dismiss.svg'

const STYLES = {
  announcementWrap: {
    backgroundColor: Palette.LIGHT_BLUE,
    borderRadius: 8,
    boxShadow: '0 30px 80px 0 rgba(0,0,0,.3)',
    maxWidth: '90%',
    textAlign: 'center',
    zIndex: 2,
    position: 'absolute',
    top: 69,
    padding: '15px 40px',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  dismisser: {
    position: 'absolute',
    top: '50%',
    right: 15,
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  text: {
    color: Palette.COAL,
    fontSize: 15,
    textDecoration: 'none',
    textTransform: 'none',
  },
  link: {
    textDecoration: 'underline',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    textTransform: 'inherit',
    background: 'none',
    border: 'none',
    color: 'inherit',
    padding: 0,
  },
}

const BANNER_COOKIE = 'banner_cookie'

class NotificationManager extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isEuropeanUnion: false,
      hasAcceptedCookies: this.hasUserAcceptedCookies(),
      isAlertVisible: false,
    }
  }

  componentDidMount() {
    const isAlertVisible = sessionStorage
      ? !sessionStorage.getItem('alertDismissed')
      : true
    // this.setState({ isAlertVisible })

    if (!this.state.hasAcceptedCookies) {
      this.checkIfIsEuropeanUnion()
    }
  }

  checkIfIsEuropeanUnion() {
    // NOTE: since we are using a hackish solution to fetch this information we
    // decided to not include this logic in sdk-inkstone.
    const request = new XMLHttpRequest()
    request.open(
      'GET',
      'https://inkstone-edge.haiku.ai/v0/integrations/cloudfront/geolocation',
      true
    )

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText)
        this.setState({ isEuropeanUnion: true })
      }
    }

    request.onerror = () => {
      this.setState({isEuropeanUnion: true})
    }

    request.send()
  }

  setCookieAsAccepted() {
    Cookies.set(BANNER_COOKIE, true, {
      domain: process.env.REACT_APP_BANNER_COOKIE_DOMAIN,
      expires: 365,
    })
    this.setState({ hasAcceptedCookies: true })
  }

  hasUserAcceptedCookies() {
    return Boolean(Cookies.get(BANNER_COOKIE))
  }

  hideAlert() {
    this.setState({ isAlertVisible: false })

    if (sessionStorage) {
      sessionStorage.setItem('alertDismissed', true)
    }
  }

  get currentNotice() {
    return (
      <div style={STYLES.announcementWrap}>
        <a
          onClick={() => this.hideAlert()}
          href="/blog/kickstart-design-and-development-with-forks/"
          style={STYLES.text}
        >
          NEW: Kickstart design & development with Forks!{' '}
          <span style={STYLES.link}>Learn more</span>
        </a>
        <img
          onClick={() => {
            this.hideAlert()
          }}
          style={STYLES.dismisser}
          src={Dismiss}
          alt="Dismiss"
        />
      </div>
    )
  }

  get cookiesNotice() {
    return (
      <div style={STYLES.announcementWrap}>
        <div style={STYLES.text}>
          We use cookies to help you log in and improve your service. &nbsp;
          <a
            style={STYLES.link}
            href="http://www.aboutcookies.org.uk/managing-cookies"
            rel="noopener noreferrer"
            target="_blank"
          >
            Manage
          </a>
          <span>&nbsp; or &nbsp;</span>
          <button
            onClick={() => {
              this.setCookieAsAccepted()
            }}
            style={STYLES.link}
          >
            Accept
          </button>
        </div>
      </div>
    )
  }

  render() {
    let out = null

    if (!this.state.hasAcceptedCookies && this.state.isEuropeanUnion) {
      out = this.cookiesNotice
    } else if (this.state.isAlertVisible) {
      out = this.currentNotice
    }

    return out
  }
}

export default NotificationManager



// WEBPACK FOOTER //
// ./src/components/notification-manager.js